import Api from '@/services/Index';

const getAll = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/ticket/event/promotion/codes', config);
}

const get = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/ticket/event/promotion/codes/' + id);
}

const store = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/ticket/event/promotion/codes', data);
}

const update = async (id, formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.put('/ticket/event/promotion/codes/' + id, formData);
}

const deleteTicket = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.delete('/ticket/event/promotion/codes/' + id);
}

const generatePromotionCode = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('ticket/event/promotion/codes/generate-personal-promotion-codes', data);
}

export default {
    getAll,
    get,
    update,
    store,
    deleteTicket,
    generatePromotionCode
}
